export const downloadAs = (filename: string) => (blob: Blob | MediaSource) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
};
